import { environment } from '../../environments/environment';

export const permission = {
    accessible :  environment.userLanding
};
